<script>
import {ProductApi} from "@core/api";
import vSelect from 'vue-select'

export default {
    components: {
        vSelect
    },
    props: {
        multiple: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            statements: [],
            selected: []
        };
    },
    created() {
        ProductApi.getAllGeneralProductStatements().then((res) => {
            this.statements = res.data;
        });
    }
}
</script>

<template>
    <v-select
        v-model="selected"
        :options="statements"
        :multiple="multiple"
        @input="$emit('input', selected)"
        label="productStatement"
    />
</template>
